module.exports = __webpack_public_path__ + "img/line-icon.2c7647ac.png";